// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.groups-page {
    padding: 24px;
    font-family: var(--font-sans, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif);
}

/* Title row — matches the plain title/DC-dropdown header used on Routing, Dashboard, DC File Upload */
.settings-title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 2px;
    margin-bottom: 8px;
}

.settings-title {
    font-family: var(--font-sans, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif);
    font-size: 25px;
    font-weight: bold;
    color: #1d2939;
    margin: 0;
    padding: 10px;
}

.settings-title-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

.customSelect {
    width: 160px;
    padding: 8px;
    font-size: 12px;
    border: 1px solid #0A74DA;
    font-weight: bold;
    background-color: white;
    border-radius: 5px;
    cursor: pointer;
}

.customSelect.disabled {
    color: grey;
    cursor: not-allowed;
}

.customSelect.enabled {
    color: #0A74DA;
}

/* Card container */
.groups-card {
    background: #ffffff;
    border: 1px solid #eceef2;
    border-radius: 14px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 8px 24px rgba(16, 24, 40, 0.06);
    overflow: hidden;
}

.groups-count {
    font-size: 12px;
    font-weight: 600;
    color: #1976d2;
    background: #e3f2fd;
    border: 1px solid #bbdefb;
    padding: 5px 13px;
    border-radius: 20px;
    white-space: nowrap;
}

/* Toolbar */
.groups-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 24px;
    border-bottom: 1px solid #f0f2f5;
    background: #fcfcfd;
}

.groups-search {
    position: relative;
    flex: 1 1;
    max-width: 420px;
    display: flex;
    align-items: center;
}

.groups-search-icon {
    position: absolute;
    left: 12px;
    color: #98a2b3;
    pointer-events: none;
}

.groups-search input {
    width: 100%;
    padding: 10px 36px 10px 38px;
    font-size: 13.5px;
    color: #1d2939;
    border: 1px solid #d0d5dd;
    border-radius: 9px;
    outline: none;
    background: #ffffff;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
    font-family: inherit;
}

.groups-search input::placeholder {
    color: #98a2b3;
}

.groups-search input:focus {
    border-color: #1976d2;
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.14);
}

.groups-search-clear {
    position: absolute;
    right: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border: none;
    border-radius: 50%;
    background: #eef1f5;
    color: #667085;
    cursor: pointer;
    transition: background 0.15s ease;
}

.groups-search-clear:hover {
    background: #e2e6ec;
}

.groups-add-btn {
    margin-left: auto;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 18px;
    font-size: 13.5px;
    font-weight: 600;
    color: #ffffff;
    border: none;
    border-radius: 9px;
    cursor: pointer;
    background: linear-gradient(120deg, #1976d2 0%, #1565c0 100%);
    box-shadow: 0 2px 6px rgba(25, 118, 210, 0.25);
    transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
    font-family: inherit;
}

.groups-add-btn:hover {
    filter: brightness(1.05);
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.32);
    transform: translateY(-1px);
}

.groups-add-btn:active {
    transform: translateY(0);
}

/* Table */
.groups-table-scroll {
    overflow-x: auto;
}

.groups-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    font-size: 13.5px;
    min-width: 640px;
}

.groups-table th {
    color: #475467;
    font-weight: 600;
    text-align: left;
    padding: 11px 16px;
    background: #f8fafc;
    font-size: 11.5px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    border-bottom: 1px solid #e9ecf1;
}

.groups-table th.action-col {
    width: 90px;
    text-align: center;
}

.groups-table td {
    padding: 13px 16px;
    text-align: left;
    color: #344054;
    vertical-align: middle;
    border-bottom: 1px solid #f2f4f7;
}

.groups-table td.action-col {
    text-align: center;
}

.groups-table tbody tr {
    transition: background-color 0.15s ease;
}

.groups-table tbody tr:hover {
    background: #f9fbff;
}

.groups-table tbody tr:last-child td {
    border-bottom: none;
}

.groups-table td.group-cell {
    font-weight: 600;
    color: #1d2939;
    font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
    font-size: 13px;
}

.group-cell-inner {
    display: flex;
    align-items: center;
}

.group-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    margin-right: 12px;
    flex-shrink: 0;
    color: #1976d2;
    background: #e3f2fd;
    box-shadow: inset 0 0 0 1px #bbdefb;
}

.desc-cell {
    color: #475467;
}

/* DC chip */
.dc-chip {
    display: inline-flex;
    align-items: center;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
    padding: 3px 10px;
    border-radius: 6px;
    color: #0d47a1;
    background: #e3f2fd;
    box-shadow: inset 0 0 0 1px rgba(13, 71, 161, 0.12);
}

/* Member count chip */
.member-chip {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    min-width: 26px;
    height: 26px;
    padding: 0 10px;
    font-size: 12px;
    font-weight: 600;
    border-radius: 20px;
    color: #344054;
    background: #f2f4f7;
    box-shadow: inset 0 0 0 1px #e4e7ec;
}

.member-chip-btn {
    border: none;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;
}

.member-chip-btn:hover {
    background: #e3f2fd;
    color: #0d47a1;
    box-shadow: inset 0 0 0 1px rgba(13, 71, 161, 0.18);
}

/* Status badge — shared with Users */
.status-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    font-weight: 600;
    padding: 3px 11px;
    border-radius: 20px;
    white-space: nowrap;
    flex-shrink: 0;
}

.status-badge .status-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    flex-shrink: 0;
}

.status-active {
    background: #d1fae5;
    color: #065f46;
    box-shadow: inset 0 0 0 1px rgba(6, 95, 70, 0.2);
}

.status-active .status-dot {
    background: #059669;
    box-shadow: 0 0 0 3px rgba(5, 150, 105, 0.25);
}

.status-inactive {
    background: #f2f4f7;
    color: #667085;
    box-shadow: inset 0 0 0 1px rgba(71, 84, 103, 0.12);
}

.status-inactive .status-dot {
    background: #98a2b3;
}

.groups-empty {
    text-align: center !important;
    color: #98a2b3;
    padding: 32px 16px !important;
    font-style: italic;
}

/* Action button (matches Users / Permission) */
.row-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    border: 1px solid transparent;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.row-btn-edit {
    color: #1976d2;
    background: #e3f2fd;
    border-color: #bbdefb;
}

.row-btn-edit:hover {
    background: #bbdefb;
}

.row-action-group {
    display: inline-flex;
    gap: 6px;
    justify-content: center;
}

.row-btn-members {
    color: #085041;
    background: #e6f6f0;
    border-color: #cdeee2;
}

.row-btn-members:hover {
    background: #d6f0e6;
}

/* ---- Manage members dialog ---- */
.members-dialog-group {
    color: #1976d2;
    font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
    font-weight: 600;
}

.members-section-label {
    font-size: 11.5px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #667085;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.members-two-col {
    display: flex;
    gap: 16px;
    align-items: flex-start;
}

.members-col {
    flex: 1 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
}

.members-scroll-box {
    max-height: 280px;
    overflow-y: auto;
    border: 1px solid #eef0f3;
    border-radius: 8px;
    padding: 4px 0;
}

.members-add-label {
    margin-top: 0;
    padding-top: 0;
    border-top: none;
}

.members-section-count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    font-size: 11px;
    border-radius: 20px;
    color: #0d47a1;
    background: #e3f2fd;
    letter-spacing: 0;
}

.members-empty {
    font-size: 13px;
    color: #98a2b3;
    font-style: italic;
    padding: 10px 2px;
}

.members-list {
    display: flex;
    flex-direction: column;
    gap: 2px;
}


.member-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 10px;
    border-radius: 10px;
    transition: background 0.12s ease;
}

.member-row:hover {
    background: #f7f9fc;
}

.member-row .avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 600;
    flex-shrink: 0;
    box-shadow: 0 0 0 2px #ffffff, 0 1px 2px rgba(16, 24, 40, 0.12);
}

.member-row .av-j { background: #b5d4f4; color: #0c447c; }
.member-row .av-s { background: #cecbf6; color: #3c3489; }
.member-row .av-a { background: #9fe1cb; color: #085041; }
.member-row .av-d { background: #f5c4b3; color: #712b13; }

.member-info {
    display: flex;
    flex-direction: column;
    line-height: 1.3;
    min-width: 0;
}

.member-name {
    font-size: 13.5px;
    font-weight: 600;
    color: #1d2939;
}

.member-email {
    font-size: 12px;
    color: #667085;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.member-action {
    margin-left: auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: 1px solid transparent;
    cursor: pointer;
    flex-shrink: 0;
    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.member-add {
    color: #085041;
    background: #e6f6f0;
    border-color: #cdeee2;
}

.member-add:hover {
    background: #d2efe4;
}

.member-remove {
    color: #b42318;
    background: #fdeceb;
    border-color: #f7d3d0;
}

.member-remove:hover {
    background: #fbdbd9;
}

/* Members search box */
.members-search {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.members-search-icon {
    position: absolute;
    left: 11px;
    color: #98a2b3;
    pointer-events: none;
}

.members-search input {
    width: 100%;
    padding: 9px 12px 9px 34px;
    font-size: 13px;
    color: #1d2939;
    border: 1px solid #d0d5dd;
    border-radius: 9px;
    outline: none;
    font-family: inherit;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.members-search input:focus {
    border-color: #1976d2;
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.14);
}
`, "",{"version":3,"sources":["webpack://./src/components/settings/Groups.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,wFAAwF;AAC5F;;AAEA,sGAAsG;AACtG;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,wFAAwF;IACxF,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,+EAA+E;IAC/E,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,0DAA0D;IAC1D,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,6DAA6D;IAC7D,8CAA8C;IAC9C,0EAA0E;IAC1E,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,+CAA+C;IAC/C,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,UAAU;AACV;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,4EAA4E;IAC5E,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB,mCAAmC;AACvC;;AAEA;IACI,cAAc;AAClB;;AAEA,YAAY;AACZ;IACI,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,mDAAmD;AACvD;;AAEA,sBAAsB;AACtB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,mDAAmD;AACvD;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mDAAmD;AACvD;;AAEA,qCAAqC;AACrC;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gDAAgD;AACpD;;AAEA;IACI,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mDAAmD;AACvD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA,+CAA+C;AAC/C;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,4EAA4E;AAChF;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,oCAAoC;AACpC;IACI,cAAc;IACd,4EAA4E;IAC5E,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,+DAA+D;AACnE;;AAEA,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;;AAEzD;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,cAAc;IACd,4EAA4E;AAChF;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,0DAA0D;AAC9D;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;AAClD","sourcesContent":[".groups-page {\n    padding: 24px;\n    font-family: var(--font-sans, \"Segoe UI\", \"Roboto\", \"Helvetica Neue\", Arial, sans-serif);\n}\n\n/* Title row — matches the plain title/DC-dropdown header used on Routing, Dashboard, DC File Upload */\n.settings-title-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 2px;\n    margin-bottom: 8px;\n}\n\n.settings-title {\n    font-family: var(--font-sans, \"Segoe UI\", \"Roboto\", \"Helvetica Neue\", Arial, sans-serif);\n    font-size: 25px;\n    font-weight: bold;\n    color: #1d2939;\n    margin: 0;\n    padding: 10px;\n}\n\n.settings-title-actions {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.customSelect {\n    width: 160px;\n    padding: 8px;\n    font-size: 12px;\n    border: 1px solid #0A74DA;\n    font-weight: bold;\n    background-color: white;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.customSelect.disabled {\n    color: grey;\n    cursor: not-allowed;\n}\n\n.customSelect.enabled {\n    color: #0A74DA;\n}\n\n/* Card container */\n.groups-card {\n    background: #ffffff;\n    border: 1px solid #eceef2;\n    border-radius: 14px;\n    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 8px 24px rgba(16, 24, 40, 0.06);\n    overflow: hidden;\n}\n\n.groups-count {\n    font-size: 12px;\n    font-weight: 600;\n    color: #1976d2;\n    background: #e3f2fd;\n    border: 1px solid #bbdefb;\n    padding: 5px 13px;\n    border-radius: 20px;\n    white-space: nowrap;\n}\n\n/* Toolbar */\n.groups-toolbar {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 16px 24px;\n    border-bottom: 1px solid #f0f2f5;\n    background: #fcfcfd;\n}\n\n.groups-search {\n    position: relative;\n    flex: 1;\n    max-width: 420px;\n    display: flex;\n    align-items: center;\n}\n\n.groups-search-icon {\n    position: absolute;\n    left: 12px;\n    color: #98a2b3;\n    pointer-events: none;\n}\n\n.groups-search input {\n    width: 100%;\n    padding: 10px 36px 10px 38px;\n    font-size: 13.5px;\n    color: #1d2939;\n    border: 1px solid #d0d5dd;\n    border-radius: 9px;\n    outline: none;\n    background: #ffffff;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n    font-family: inherit;\n}\n\n.groups-search input::placeholder {\n    color: #98a2b3;\n}\n\n.groups-search input:focus {\n    border-color: #1976d2;\n    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.14);\n}\n\n.groups-search-clear {\n    position: absolute;\n    right: 8px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 22px;\n    height: 22px;\n    border: none;\n    border-radius: 50%;\n    background: #eef1f5;\n    color: #667085;\n    cursor: pointer;\n    transition: background 0.15s ease;\n}\n\n.groups-search-clear:hover {\n    background: #e2e6ec;\n}\n\n.groups-add-btn {\n    margin-left: auto;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 18px;\n    font-size: 13.5px;\n    font-weight: 600;\n    color: #ffffff;\n    border: none;\n    border-radius: 9px;\n    cursor: pointer;\n    background: linear-gradient(120deg, #1976d2 0%, #1565c0 100%);\n    box-shadow: 0 2px 6px rgba(25, 118, 210, 0.25);\n    transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;\n    font-family: inherit;\n}\n\n.groups-add-btn:hover {\n    filter: brightness(1.05);\n    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.32);\n    transform: translateY(-1px);\n}\n\n.groups-add-btn:active {\n    transform: translateY(0);\n}\n\n/* Table */\n.groups-table-scroll {\n    overflow-x: auto;\n}\n\n.groups-table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    font-size: 13.5px;\n    min-width: 640px;\n}\n\n.groups-table th {\n    color: #475467;\n    font-weight: 600;\n    text-align: left;\n    padding: 11px 16px;\n    background: #f8fafc;\n    font-size: 11.5px;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    border-bottom: 1px solid #e9ecf1;\n}\n\n.groups-table th.action-col {\n    width: 90px;\n    text-align: center;\n}\n\n.groups-table td {\n    padding: 13px 16px;\n    text-align: left;\n    color: #344054;\n    vertical-align: middle;\n    border-bottom: 1px solid #f2f4f7;\n}\n\n.groups-table td.action-col {\n    text-align: center;\n}\n\n.groups-table tbody tr {\n    transition: background-color 0.15s ease;\n}\n\n.groups-table tbody tr:hover {\n    background: #f9fbff;\n}\n\n.groups-table tbody tr:last-child td {\n    border-bottom: none;\n}\n\n.groups-table td.group-cell {\n    font-weight: 600;\n    color: #1d2939;\n    font-family: \"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, monospace;\n    font-size: 13px;\n}\n\n.group-cell-inner {\n    display: flex;\n    align-items: center;\n}\n\n.group-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n    border-radius: 8px;\n    margin-right: 12px;\n    flex-shrink: 0;\n    color: #1976d2;\n    background: #e3f2fd;\n    box-shadow: inset 0 0 0 1px #bbdefb;\n}\n\n.desc-cell {\n    color: #475467;\n}\n\n/* DC chip */\n.dc-chip {\n    display: inline-flex;\n    align-items: center;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    padding: 3px 10px;\n    border-radius: 6px;\n    color: #0d47a1;\n    background: #e3f2fd;\n    box-shadow: inset 0 0 0 1px rgba(13, 71, 161, 0.12);\n}\n\n/* Member count chip */\n.member-chip {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n    min-width: 26px;\n    height: 26px;\n    padding: 0 10px;\n    font-size: 12px;\n    font-weight: 600;\n    border-radius: 20px;\n    color: #344054;\n    background: #f2f4f7;\n    box-shadow: inset 0 0 0 1px #e4e7ec;\n}\n\n.member-chip-btn {\n    border: none;\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease;\n}\n\n.member-chip-btn:hover {\n    background: #e3f2fd;\n    color: #0d47a1;\n    box-shadow: inset 0 0 0 1px rgba(13, 71, 161, 0.18);\n}\n\n/* Status badge — shared with Users */\n.status-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 11px;\n    font-weight: 600;\n    padding: 3px 11px;\n    border-radius: 20px;\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n\n.status-badge .status-dot {\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.status-active {\n    background: #d1fae5;\n    color: #065f46;\n    box-shadow: inset 0 0 0 1px rgba(6, 95, 70, 0.2);\n}\n\n.status-active .status-dot {\n    background: #059669;\n    box-shadow: 0 0 0 3px rgba(5, 150, 105, 0.25);\n}\n\n.status-inactive {\n    background: #f2f4f7;\n    color: #667085;\n    box-shadow: inset 0 0 0 1px rgba(71, 84, 103, 0.12);\n}\n\n.status-inactive .status-dot {\n    background: #98a2b3;\n}\n\n.groups-empty {\n    text-align: center !important;\n    color: #98a2b3;\n    padding: 32px 16px !important;\n    font-style: italic;\n}\n\n/* Action button (matches Users / Permission) */\n.row-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n    border-radius: 8px;\n    border: 1px solid transparent;\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\n.row-btn-edit {\n    color: #1976d2;\n    background: #e3f2fd;\n    border-color: #bbdefb;\n}\n\n.row-btn-edit:hover {\n    background: #bbdefb;\n}\n\n.row-action-group {\n    display: inline-flex;\n    gap: 6px;\n    justify-content: center;\n}\n\n.row-btn-members {\n    color: #085041;\n    background: #e6f6f0;\n    border-color: #cdeee2;\n}\n\n.row-btn-members:hover {\n    background: #d6f0e6;\n}\n\n/* ---- Manage members dialog ---- */\n.members-dialog-group {\n    color: #1976d2;\n    font-family: \"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, monospace;\n    font-weight: 600;\n}\n\n.members-section-label {\n    font-size: 11.5px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: #667085;\n    margin-bottom: 10px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.members-two-col {\n    display: flex;\n    gap: 16px;\n    align-items: flex-start;\n}\n\n.members-col {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n}\n\n.members-scroll-box {\n    max-height: 280px;\n    overflow-y: auto;\n    border: 1px solid #eef0f3;\n    border-radius: 8px;\n    padding: 4px 0;\n}\n\n.members-add-label {\n    margin-top: 0;\n    padding-top: 0;\n    border-top: none;\n}\n\n.members-section-count {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 20px;\n    height: 20px;\n    padding: 0 6px;\n    font-size: 11px;\n    border-radius: 20px;\n    color: #0d47a1;\n    background: #e3f2fd;\n    letter-spacing: 0;\n}\n\n.members-empty {\n    font-size: 13px;\n    color: #98a2b3;\n    font-style: italic;\n    padding: 10px 2px;\n}\n\n.members-list {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n\n.member-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 8px 10px;\n    border-radius: 10px;\n    transition: background 0.12s ease;\n}\n\n.member-row:hover {\n    background: #f7f9fc;\n}\n\n.member-row .avatar {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 34px;\n    height: 34px;\n    border-radius: 50%;\n    font-size: 12px;\n    font-weight: 600;\n    flex-shrink: 0;\n    box-shadow: 0 0 0 2px #ffffff, 0 1px 2px rgba(16, 24, 40, 0.12);\n}\n\n.member-row .av-j { background: #b5d4f4; color: #0c447c; }\n.member-row .av-s { background: #cecbf6; color: #3c3489; }\n.member-row .av-a { background: #9fe1cb; color: #085041; }\n.member-row .av-d { background: #f5c4b3; color: #712b13; }\n\n.member-info {\n    display: flex;\n    flex-direction: column;\n    line-height: 1.3;\n    min-width: 0;\n}\n\n.member-name {\n    font-size: 13.5px;\n    font-weight: 600;\n    color: #1d2939;\n}\n\n.member-email {\n    font-size: 12px;\n    color: #667085;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.member-action {\n    margin-left: auto;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    border: 1px solid transparent;\n    cursor: pointer;\n    flex-shrink: 0;\n    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\n.member-add {\n    color: #085041;\n    background: #e6f6f0;\n    border-color: #cdeee2;\n}\n\n.member-add:hover {\n    background: #d2efe4;\n}\n\n.member-remove {\n    color: #b42318;\n    background: #fdeceb;\n    border-color: #f7d3d0;\n}\n\n.member-remove:hover {\n    background: #fbdbd9;\n}\n\n/* Members search box */\n.members-search {\n    position: relative;\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.members-search-icon {\n    position: absolute;\n    left: 11px;\n    color: #98a2b3;\n    pointer-events: none;\n}\n\n.members-search input {\n    width: 100%;\n    padding: 9px 12px 9px 34px;\n    font-size: 13px;\n    color: #1d2939;\n    border: 1px solid #d0d5dd;\n    border-radius: 9px;\n    outline: none;\n    font-family: inherit;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.members-search input:focus {\n    border-color: #1976d2;\n    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.14);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
